import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/CheckBoxOutlineBlank';

class SquareIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default SquareIcon;
